import React from 'react';

import { Render, Td, Tr } from '../../../components';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { DocumentActions } from '../../document/components';
import { formatDate } from '../../../utils/formatting';

export default function InsuredDocumentRow({ insuredDocument }) {
  const { document, client, vehicle, insured, effectiveDate, expirationDate } = insuredDocument;
  const isDocumentRelationship = insuredDocument.source === 'DOCUMENT_RELATIONSHIP';

  return (
    <Tr>
      <Td>{document?.name}</Td>
      <Td>
        <Link to={`/clients/${client?.id}`}>{client?.name}</Link>
      </Td>
      <Td>
        <VinUnitNumberCell vin={vehicle?.vin} unitNumber={vehicle?.unitNumber} vehicleId={vehicle?.id} />
      </Td>
      <Td>
        {isDocumentRelationship ? (
          <DateRangeCell effectiveDate={effectiveDate} expirationDate={expirationDate} />
        ) : (
          <EmptyCell text="—" />
        )}
      </Td>
      <Td>
        <DocumentActions
          redirectUrl={`/insureds/${insured?.id}/documents`}
          document={insuredDocument}
          showVersions={isDocumentRelationship}
        />
      </Td>
    </Tr>
  );
}

const VinUnitNumberCell = ({ vin, unitNumber, vehicleId }) => {
  if (!vin && !unitNumber) return <EmptyCell />;

  return (
    <div>
      <Render if={!unitNumber}>
        <div>
          <Link to={`/vehicles/${vehicleId}`}>{vin}</Link> /{' '}
          <span className="font-weight-300 fs-xs font-italic text-muted">None</span>
        </div>
      </Render>
      <Render if={!!unitNumber}>
        <Link to={`/vehicles/${vehicleId}`}>{vin}</Link> / {unitNumber}
      </Render>
    </div>
  );
};

const DateRangeCell = ({ effectiveDate, expirationDate }) => {
  if (!effectiveDate && !expirationDate) return <EmptyCell text="—" />;
  const effective = effectiveDate ? formatDate(effectiveDate) : '—';
  const expiration = expirationDate ? formatDate(expirationDate) : 'Current';
  return <div className="font-weight-400">{`${effective} - ${expiration}`}</div>;
};

const EmptyCell = ({ text = 'None' }) => <div className="font-weight-300 fs-xs font-italic text-muted">{text}</div>;
